import React, { FC, useRef } from 'react';
import { isEditorActive } from '@sitecore-jss/sitecore-jss-react';
import InteractiveImageHotspot from './components/interactiveImageHotspot';
import InteractiveImageText from './components/interactiveImageText';
import { TInteractiveImageProps } from './types/interactiveImage.types';

const InteractiveImage: FC<TInteractiveImageProps> = (props) => {
  const isEE = isEditorActive();
  const splitModuleContainerRef = useRef<HTMLDivElement | null>(null);
  return (
    <>
      <section className="interactive-image">
        <div className="interactive-image__container">
          <InteractiveImageHotspot {...props} isEE={isEE} splitModuleContainerRef={splitModuleContainerRef} />
          <InteractiveImageText {...props} isEE={isEE} />
        </div>
      </section>
      <div ref={splitModuleContainerRef}></div>
    </>
  );
};

export default InteractiveImage;
